import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { ITrangThaiHocSinh } from '../../../models/response/category/ITrangThaiHocSinh';
import { ITrangThaiHocSinhItemRequest } from '../../../models/response/category/ITrangThaiHocSinhItemRequest';
import { eTrangThaiHocSinhActionTypeIds } from '../../action-types/trang-thai-hoc-sinh/ITrangThaiHocSinhActionTypes';
import { actions } from '../../actions/actionsWrapper';
import { ITrangThaiHocSinhActionTypes } from './../../action-types/trang-thai-hoc-sinh/ITrangThaiHocSinhActionTypes';
const crmSurveyFormWrapperAction= actions.crmSurveyFormWrapper;
export function* trangThaiHocSinhSaga(): any {
    yield takeLatest(eTrangThaiHocSinhActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eTrangThaiHocSinhActionTypeIds.LOAD_CHECKDANGKY_START, loadCheckDangKyWorker)
    yield takeLatest(eTrangThaiHocSinhActionTypeIds.LOAD_COSO_START, loadCosoWorker)
    yield takeEvery(eTrangThaiHocSinhActionTypeIds.SAVE_START, saveWorker)
    // yield takeEvery(eTrangThaiHocSinhActionTypeIds.INSERT_MULTIPLE_START, insertMultipleWorker)
    yield takeEvery(eTrangThaiHocSinhActionTypeIds.UPDATE_START, updateWorker)
    yield takeEvery(eTrangThaiHocSinhActionTypeIds.UPDATE_THU_TU_START, updateThuTuWorker)
    yield takeEvery(eTrangThaiHocSinhActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.trangThaiHocSinh.selectAll)
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.LOAD_SUCCESS(res.data))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* loadCheckDangKyWorker(data: any): any {
    const res: IBaseResponeModel = yield call([apiWrapper.trangThaiHocSinh, apiWrapper.trangThaiHocSinh.selectAllCheckDangKy], data.payload)
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.LOAD_CHECKDANGKY_SUCCESS(res.data))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.LOAD_CHECKDANGKY_ERROR(res.message ?? "Error"))
    }
}

function* loadCosoWorker(data: any): any {
    const res: IBaseResponeModel = yield call([apiWrapper.trangThaiHocSinh, apiWrapper.trangThaiHocSinh.selectByCoSo], data.payload)
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.LOAD_COSO_SUCCESS(res.data))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.LOAD_COSO_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: ITrangThaiHocSinhActionTypes): any {
    const payload: ITrangThaiHocSinh = action.payload as ITrangThaiHocSinh;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.trangThaiHocSinh.update, payload)
    } else {
        res = yield call(apiWrapper.trangThaiHocSinh.insert, payload)
    }
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.SAVE_SUCESS(res.data))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.SAVE_ERROR(res.message ?? "Error"))
    }
}

// function* insertMultipleWorker(action: ITrangThaiHocSinhActionTypes): any {
//     const payload: ITrangThaiHocSinhCoSoItemRequest = {
//         items: action.payload as ITrangThaiHocSinh[], // Sử dụng đúng thuộc tính
//     };

//     // Thay đổi cách gọi `call` để truyền đối số đúng định dạng.
//     const res: IBaseResponeModel = yield call([apiWrapper.trangThaiHocSinh, apiWrapper.trangThaiHocSinh.insertMultiple], payload);
    
//     if (res.is_success) {
//         yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.INSERT_MULTIPLE_SUCCESS(res.data));
//     } else {
//         yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.INSERT_MULTIPLE_ERROR(res.message ?? "Error"));
//     }
// }

function* updateWorker(action: ITrangThaiHocSinhActionTypes): any {
    const payload: ITrangThaiHocSinh = action.payload as ITrangThaiHocSinh;
    const res: IBaseResponeModel = yield call(apiWrapper.trangThaiHocSinh.update, payload)
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.UPDATE_SUCCESS(res.data))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.UPDATE_ERROR(res.message ?? "Error"))
    }
}

function* updateThuTuWorker(action: ITrangThaiHocSinhActionTypes): any {
    const payload: ITrangThaiHocSinhItemRequest = action.payload as ITrangThaiHocSinhItemRequest;
    const res: IBaseResponeModel = yield call(apiWrapper.trangThaiHocSinh.updateThuTuAsync, payload)
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.UPDATE_THU_TU_SUCCESS(res.data))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.UPDATE_THU_TU_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: ITrangThaiHocSinhActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.trangThaiHocSinh.delete, payload)
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.DELETE_SUCCESS(undefined))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiHocSinh.DELETE_ERROR(res.message ?? "Error"))
    }
}

